const initialState = {
  watchLists: [],
  dataTotal: [],
  dataTotalLoading: true
}

function dataTotalReducer(state = initialState, action) {
  switch (action.type) {
    case 'ADDWATCHLIST':
      const newWatchLists = state.watchLists.concat(action.payload)
      return {...state, watchLists: newWatchLists}

    case 'SET_DATA_TOTAL':
      return {...state, dataTotal: action.payload}

    case 'SET_DATA_TOTAL_LOADING':
      return {...state, dataTotalLoading: action.args}

    default:
      return state
  }
}

export default dataTotalReducer